import { css } from "styled-components";
import type { DefaultTheme } from "styled-components";

export type CardStrokeEmphasis = "default" | "strong";

/**
 * The dark design system outlines its cards in border/default, and deal cards
 * in border/strong. Light carries no stroke from this helper at all: most of
 * these cards are borderless on the light palette, and the ones that are not
 * declare their own light border, which the dark outline then overrides.
 */
export const cardStrokeColor = (
  theme: DefaultTheme,
  emphasis: CardStrokeEmphasis = "default"
): string =>
  theme.mode === "dark"
    ? theme.colors.ui.border[emphasis]
    : theme.colors.ui.border.default;

export const cardStrokeWith = (emphasis: CardStrokeEmphasis) => css`
  ${({ theme }) =>
    theme.mode === "dark" &&
    css`
      border: ${theme.stroke.md}px solid ${theme.colors.ui.border[emphasis]};
    `}
`;

export const cardStroke = cardStrokeWith("default");
